import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import styles from './UnitDetailsSummaryCard.styles';

export default function UnitDetailsSummaryCard({ summaryItems = [], dash }) {
  return (
    <Card sx={styles.summaryCard}>
      <CardContent sx={styles.summaryCardContent}>
        <Box sx={styles.contentRow}>
          {summaryItems.map(([label, value]) => (
            <Box key={label} sx={styles.item}>
              <Box sx={styles.textBox}>
                <Typography sx={styles.label}>{label}</Typography>
                <Typography sx={styles.value}>{dash(value)}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
